// extracted by mini-css-extract-plugin
module.exports = {"dialog":"FireflyOnboardingDialog_dialog__fSwUq","content":"FireflyOnboardingDialog_content__Y0Ngx","close-button":"FireflyOnboardingDialog_close-button__lmdz2"};